import { inject, Pipe, PipeTransform } from '@angular/core';
import { LocalizedRouteService } from '@lexplus-shared-lib';
import { LOCALIZED_USER_ROUTES, USER_ROUTES_IDS } from '../../localized-user-routes-const';

@Pipe({
  name: 'userPath',
})
export class UserPathPipe implements PipeTransform {
  private readonly localizedRouteService = inject(LocalizedRouteService);

  public transform(routeId: keyof typeof USER_ROUTES_IDS): string {
    return `/${this.localizedRouteService.getLocalizedRoute(LOCALIZED_USER_ROUTES[USER_ROUTES_IDS[routeId]])}`;
  }
}
